import React, {Component} from "react";
import {Button, Card, DatePicker, Input} from "antd";
import PageHeaderLayout from "../../layout/PageHeaderLayout";
import StandardTable from "../../components/StandardTable";
import * as api from "../../api/processReport";


class ProcessReport extends Component {

    dataTable = undefined;

    state = {
        searchKeyword: null,
        createDate: [],
    }

    columns = [
        {
            title: '产品ID',
            dataIndex: 'product_no'
        },
        {
            title: '采购单号 ',
            dataIndex: 'purchase_no'
        },
        {
            title: '行号',
            dataIndex: 'line_no'
        },
        {
            title: '工序',
            dataIndex: 'process_name'
        },
        {
            title: '数量',
            dataIndex: 'value'
        },
        {
            title: '设备编号',
            dataIndex: 'machine_no'
        },
        {
            title: '员工',
            dataIndex: 'employee_name'
        },
        {
            title: '批次',
            dataIndex: 'batch_no'
        },
        {
            title: '时间',
            dataIndex: 'create_time'
        },
    ]

    handleExport = () => {
        api.exportProcessReport(this.state.searchKeyword, this.state.createDate).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', '生产汇报明细.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    }

    render() {
        return (
            <PageHeaderLayout title={'生产汇报明细'} content={(
                <div style={{textAlign: 'center'}}>
                    <Input.Search style={{width: 500}}
                                  enterButton="搜索"
                                  onSearch={(value) => this.setState({searchKeyword: value})}
                    />
                    <div style={{marginTop: 15}}>
                        <span><label>创建时间：</label>
                                <DatePicker.RangePicker size='small'
                                                        onChange={value => {
                                                            this.setState({createDate: value}, () => {
                                                                this.dataTable.fetch()
                                                            })
                                                        }}/>
                        </span>
                    </div>
                </div>
            )}>
                <Card>
                    <div style={{marginBottom: 10}}>
                        <Button type={'primary'} onClick={() => this.handleExport()}>导出</Button>
                    </div>
                    <StandardTable url={'/api/order/process/report'}
                                   ref={table => this.dataTable = table}
                                   columns={this.columns}
                                   filters={{
                                       createDate: this.state.createDate,
                                   }}
                                   keyword={this.state.searchKeyword}/>
                </Card>
            </PageHeaderLayout>
        )
    }
}

export default ProcessReport
